export function getAuthUser(state) {
  return state.session.account;
}

export function getUserToken(state) {
  return state.session.token;
}

export function isLoggedIn(state) {
  const token = getUserToken(state);
  return !!token;
}

export function shortnameSelector(state) {
  const account = getAuthUser(state);
  if (!account) {
    return "Anonymous";
  }

  const { name } = account;
  if (!name) {
    return "No Name";
  }

  const [first, last] = name.split(" ");
  if (!last || !last[0]) {
    return first;
  }
  return `${first} ${last[0]}.`;
}
